var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base-table__footer" },
    [
      _c(
        "div",
        {
          staticClass:
            "base-table__footer-left d-flex align-center az-gap-small"
        },
        [
          _vm.showItemsPerPageSelector
            ? _c(
                "div",
                { staticClass: "base-table__page-size d-flex align-center" },
                [
                  _c(
                    "span",
                    { staticClass: "base-table__footer-info az-ds-aux" },
                    [_vm._v("Mostrar")]
                  ),
                  _c("v-select", {
                    staticClass: "base-table__page-size-select az-ds-aux",
                    attrs: {
                      value: _vm.itemsPerPageModel,
                      items: _vm.selectOptions,
                      "menu-props": { offsetY: true },
                      "hide-details": "",
                      dense: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("change-items-per-page", $event)
                      }
                    }
                  }),
                  _c(
                    "span",
                    { staticClass: "base-table__footer-info az-ds-aux" },
                    [_vm._v("·")]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass:
                "base-table__footer-info base-table__summary az-ds-aux"
            },
            [_vm._v(" " + _vm._s(_vm.footerSummary) + " ")]
          )
        ]
      ),
      _vm.paginationData.pageCount > 1
        ? _c("v-pagination", {
            staticClass: "base-table__pagination",
            attrs: {
              value: _vm.paginationData.page,
              length: _vm.paginationData.pageCount,
              "total-visible": 5,
              color: "black"
            },
            on: {
              input: function($event) {
                return _vm.$emit("go-to-page", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }